import { endOfMonth, endOfYear, startOfDay, startOfMonth, startOfYear, subMonths, subYears } from 'date-fns';

import { translate } from '../../common/helpers/translate.helper';

interface ReferencePeriodPreset {
    label: string;
    from: Date;
    to: Date;
}

export const useDemandDefinitionReferencePeriodPresets = (): ReferencePeriodPreset[] => {
    const today = new Date();
    const lastMonthEnd = startOfDay(endOfMonth(subMonths(today, 1)));
    const lastYear = subYears(today, 1);

    return [
        {
            label: translate('demandDefinition.last12Months'),
            from: startOfMonth(subMonths(today, 12)),
            to: lastMonthEnd,
        },
        {
            label: translate('demandDefinition.last24Months'),
            from: startOfMonth(subMonths(today, 24)),
            to: lastMonthEnd,
        },
        {
            label: translate('demandDefinition.lastCalendarYear'),
            from: startOfYear(lastYear),
            to: startOfDay(endOfYear(lastYear)),
        },
        {
            label: translate('demandDefinition.last2CalendarYears'),
            from: startOfYear(subYears(today, 2)),
            to: startOfDay(endOfYear(lastYear)),
        },
    ];
};
